///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import Tag from "./Tag";
import getBidTags from "../helpers/getBidTags";

const BidTags = ({ bid, user }) => (
  <>
    {getBidTags(bid, user).map(t => (
      <Tag
        key={`tag-${bid.bidId}-${t.tag}`}
        className="mx-1 px-4 bg-light-grey-1 bid-tags"
        data-testid={t.testId}
      >
        {t.tag}
      </Tag>
    ))}
  </>
);

export default BidTags;
